  export const ALL_STATUS_OPTIONS = [
    { label: 'Tất cả', value: 0},
    { label: 'Sử dụng', value: 1 },
    { label: 'Tạm ngưng', value: 2 }, 
    { label: 'Không sử dụng', value: 3 },
  ];
    export const STATUS_OPTIONS = [
    { label: 'Sử dụng', value: 1 },
    { label: 'Tạm ngưng', value: 2 }, 
    { label: 'Không sử dụng', value: 3 },
  ];